"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var owa_header_toast_notification_1 = require("owa-header-toast-notification");
exports.default = legacy_1.action('handleToggleFavoritePersonaError')(function handleToggleFavoritePersonaError(error, retryFunction) {
    var isAddFailure = error.type === 'AddFavoritePersonaError';
    var notificationType = isAddFailure
        ? owa_header_toast_notification_1.NotificationActionType.AddFavoritePersonaFailedNotification
        : owa_header_toast_notification_1.NotificationActionType.RemoveFavoritePersonaFailedNotification;
    owa_header_toast_notification_1.ensureNotificationHandlerRegistered(notificationType, function () { return retryFunction(); });
    var notification = {
        actionType: notificationType,
        title: isAddFailure
            ? owa_mail_strings_1.default.favoritesErrorTitleText
            : owa_mail_strings_1.default.favoritesRemoveErrorTitleText,
        description: isAddFailure
            ? owa_mail_strings_1.default.favoritesErrorDescriptionText
            : owa_mail_strings_1.default.favoritesRemoveErrorDescriptionText,
        actionLink: owa_mail_strings_1.default.favoritesErrorTryAgainButtonText,
        cancelLink: owa_mail_strings_1.default.favoritesErrorCloseButtonText,
    };
    owa_header_toast_notification_1.addNotification(notification);
});
//# sourceMappingURL=handleToggleFavoritePersonaError.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/people/handleToggleFavoritePersonaError.js
// module id = 4654
// module chunks = 14